import mitt, { Emitter } from 'mitt';

type Events = {
  isCollapse: boolean;
};

const emitter: Emitter<Events> = mitt<Events>();

export default emitter;